import { SapFlow, SapFlowConfig, SapFlowConfigProcessNode, SapFlowItemNode, FileFormat } from '../../../types';

const useSapFlow = () => {
  const sortConfigProcessNode = (sapFlowConfig: SapFlowConfig): SapFlowConfigProcessNode[] => {
    const processnodes = sapFlowConfig.processnodeconfigs.map((node) => ({ ...node }));
    processnodes.sort((a, b) => a.order - b.order);
    return processnodes;
  };

  const getSuppliedItems = (sapFlow: SapFlow): SapFlowItemNode[] => {
    return sapFlow.itemnodes.filter((item) => item.type === 'SUPPLIED');
  };

  const getUploadUrl = (
    transactionId: string,
    itemId: string,
    visualize: boolean
  ): string => {
    let params = `?trans_id=${transactionId}`;
    params += `&item_id=${itemId}`;
    if (visualize) params += `&pc_visualize=true`;
    return `${process.env.REACT_APP_GEOSAP_SERVERURL}/file_manager/upload${params}`;
  };

  const getFileFormatNames = (sapFlow: SapFlow): string[] => {
    const namesMap = getSuppliedItems(sapFlow).reduce(
      (map, itemNode) => ({ ...map, [itemNode.fileformat]: itemNode.fileformat }),
      {}
    );
    return Object.keys(namesMap);
  };

  const getExtensions = (formatName: string, fileFormats: FileFormat[]) => {
    return fileFormats.find((f) => f.name === formatName).acceptedFileExtensions;
  };

  return { sortConfigProcessNode, getSuppliedItems, getUploadUrl, getFileFormatNames, getExtensions };
};

export default useSapFlow;
